import { deliveryRequestStrings } from '@data/deliveryRequest';
import { createStrings } from '@utils/local';
import { PageMeta } from '@utils/pages';

const strings = createStrings({
  ja: {
    title: deliveryRequestStrings.deliveryRequest,
  },
});

export const meta: PageMeta = {
  title: strings.title,
  listed: false,
  staffOnly: true,
};
